import { api } from './Api';

let epoch = 0;
const pending = new Map();
const listeners = new Set();
export const historyIdentity = () => epoch;
export const subscribeHistoryIdentity = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const clearHistoryRequests = () => {
  epoch += 1;
  pending.forEach(({ controller }) => controller.abort());
  pending.clear();
  listeners.forEach((listener) => listener());
};

// Only pending transport work is shared; settled responses are never cached.
export const historyGet = (route, params, signal) => {
  const key = JSON.stringify([epoch, route, Object.keys(params).sort().map((k) => [k, params[k]])]);
  let entry = pending.get(key);
  if (!entry) {
    const controller = new AbortController();
    entry = { controller, consumers: new Set() };
    entry.promise = api.get(route, params, { signal: controller.signal }).finally(() => {
      if (pending.get(key) === entry) pending.delete(key);
    });
    pending.set(key, entry);
  }
  const consumer = {};
  entry.consumers.add(consumer);
  return new Promise((resolve, reject) => {
    const release = () => {
      entry.consumers.delete(consumer);
      if (signal) signal.removeEventListener('abort', abort);
    };
    const abort = () => {
      release();
      if (!entry.consumers.size) {
        entry.controller.abort();
        if (pending.get(key) === entry) pending.delete(key);
      }
      reject(Object.assign(new Error('History request cancelled'), { name: 'AbortError' }));
    };
    if (signal?.aborted) abort();
    else if (signal) signal.addEventListener('abort', abort);
    entry.promise.then((value) => { release(); resolve(value); }, (error) => { release(); reject(error); });
  });
};

export const historyIdentityMiddleware = (store) => (next) => (action) => {
  const before = store.getState().user?.user;
  if (['user/logoutRequest', 'user/signInRequest'].includes(action.type)) clearHistoryRequests();
  const result = next(action);
  const after = store.getState().user?.user;
  if (before !== after) clearHistoryRequests();
  return result;
};
